import { routesMap } from "@/constants/routes";
import { useLocation } from "react-router";

const useCurrentStep = () => {
  const { pathname } = useLocation();
  const currentStep = routesMap.get(pathname);
  return currentStep ? {
    ...currentStep,
    path: pathname,
  } : undefined;
};

export default useCurrentStep;
